import React, { useReducer } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import SiteInfo from "./SiteInfo";
import OICSnackbar from "./OICSnackbar";

import reducer from "../reducers/siteInfoReducer";
import initialState from "../reducers/initialState";

export default function AppLayout() {
  const location = useLocation();
  const [stateSI, dispatchSI] = useReducer(reducer, initialState.siteInfo);
  const disableSearch = location.pathname.startsWith("/firearm/");

  return (
    <>
      <Header dispatchSI={dispatchSI} disableSearch={disableSearch} />
      <Outlet context={{ dispatchSI }} />
      <SiteInfo stateSI={stateSI} dispatchSI={dispatchSI} />
      <OICSnackbar />
    </>
  );
}
